<template>
  <div class="rulebook-page">
    <h4 class="fg-blue">The Iron Epic</h4>

  </div>
</template>

<style scoped lang="scss">
@import '@/assets/styles/book/bookview';

p {
  font-size: 1em;
  color: #303030;
  margin-bottom: 15px;
}
</style>

<script setup lang="ts">

</script>
